export default __webpack_public_path__ + "img/ef54e3694923cc3884a2362b5adc54da.mp4";